import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import { useBloomBasename } from '@jane/bloom/hooks/useBloomBasename';
import type { Payload } from '@jane/bloom/routes/$basename.api.user-exists/types';
import { buildFormData } from '@jane/bloom/utils/formData';

export const useCheckJaneUserExists = () => {
  const basename = useBloomBasename();
  const fetcher = useFetcher<{ isNewUser: boolean }>({
    key: 'check-user-exists',
  });

  const checkUserExists = useCallback(
    (email: string) => {
      const formData: Payload = {
        email,
        referrer: window.location.href,
      };
      return fetcher.submit(buildFormData(formData), {
        action: `${basename}api/user-exists`,
        method: 'post',
        preventScrollReset: true,
      });
    },
    [basename, fetcher]
  );

  return { checkUserExists, fetcher };
};
